export function isBulkOrderEnabled(): boolean {
  // Default ON (beta). Can be disabled per-environment.
  try {
    const v = (import.meta as any)?.env?.VITE_BULK_ORDER_ENABLED;
    if (String(v).trim() === "0" || String(v).trim().toLowerCase() === "false") return false;
  } catch {}
  return true;
}

